import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router, ActivatedRouteSnapshot } from '@angular/router';
import { BackendService } from '../../core/backend.service';
import { SecurityService } from '../../security/security.service';
import { Operacion } from '../operaciones/operacion.model';
import { EnvironmentProvider } from '../../core/browser-providers';
import { Environment } from '../../../environments/enviroment.model';
import { MatPaginatorIntl } from '@angular/material';
import { UpdateEventService } from '../../shared-services/update-event.service';
import { MediaService } from '../../shared-services/media.service';
import { Saldo } from '../saldo.model';
import { TipoOperacion } from '../operaciones/tipoOperacion.model';

interface Filters {
  page: number;
  size: number;
}

interface Page {
  pageIndex: number;
  pageSize: number;
}

@Component({
  selector: 'app-ver-saldos',
  templateUrl: './ver-saldos.component.html',
  styleUrls: ['./ver-saldos.component.scss']
})
export class VerSaldosComponent implements OnInit {

  cliente: any;
  saldos: Saldo[];
  operacionesList: Operacion[];
  TipoOperacion: TipoOperacion = new TipoOperacion;
  isLoading: boolean;
  totalItems: number;


  private filters: Filters = {
    page: 0,
    size: 10,
  };

  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    public router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
    public securityService: SecurityService,
  ) {
  }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.cliente = data.cliente;
      this.saldos = data.saldos;
    });
    this.getOperacionesList();
  }

  async getOperacionesList() {
    this.operacionesList = await this.backendService.get(Operacion, Operacion.path + this.cliente.id, null).toPromise();
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
  }

  onAddOperacion() {
    this.router.navigate(['/operaciones/agregar/' + this.cliente.id]);
  }

  getFilters() {
    return this.filters;
  }
}



// WEBPACK FOOTER //
// ./src/app/cliente/ver-saldos/ver-saldos.component.ts